<template>
  <svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="14.6981" cy="14.0624" rx="13.7255" ry="13.7255" fill="#E42877"/>
<path d="M19.8426 8.29785C15.5995 8.29785 14.8301 11.0502 14.8301 14.0626C14.8301 17.0749 15.5776 19.8273 19.8426 19.8273C24.0856 19.8273 24.8331 17.0749 24.8331 14.0626C24.855 11.0502 24.1076 8.29785 19.8426 8.29785ZM19.8426 17.1833C18.1717 17.1833 17.9299 16.0347 17.9299 14.1926C17.9299 12.3505 18.1717 11.2235 19.8426 11.2235C21.5134 11.2235 21.7332 12.3722 21.7332 14.1926C21.7552 16.0347 21.5134 17.1833 19.8426 17.1833Z" fill="white"/>
<path d="M8.98189 15.3412H10.9605V15.5362C10.9605 16.7715 11.0045 17.335 9.48754 17.335C8.08053 17.335 7.59687 16.7065 7.59687 14.1492C7.59687 11.5053 8.38831 11.1802 9.59746 11.1802C10.4988 11.1802 11.1144 11.4186 11.642 11.7003L13.2689 9.1864C12.4335 8.66627 11.1803 8.29785 9.75135 8.29785C5.81612 8.29785 4.54102 10.1616 4.54102 14.0626C4.54102 17.465 5.46437 19.8273 9.20174 19.8273C9.86128 19.8273 10.4329 19.7839 10.9165 19.6972H13.7306V14.9944V12.914H9.31166L8.98189 15.3412Z" fill="white"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>